import { createApolloClient } from '@polf/shared/apollo'
import { possibleTypesData } from '@polf/shared/codegen'

import { getActiveOpponentKey } from './opponent-auth-state'

/**
 * Apollo client for the public Beat-the-Pro audience view — opponent-key
 * scoped, separate from the player-key client so the two never share a
 * cache or a header. Same `/graphql` endpoint (vite proxies to the API).
 */
const { possibleTypes } = possibleTypesData

export const apolloOpponent = createApolloClient({
  authMode: 'opponent',
  uri: '/graphql',
  getNanoIdKey: getActiveOpponentKey,
  possibleTypes,
})
